import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { VerifyAuthPage } from './verify-auth.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: VerifyAuthPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [VerifyAuthPage],
})
export class VerifyAuthPageModule {}
